import { BtnStyled } from './СhooseYourBreakfast.styled';

const СhooseYourBreakfast = () => {
  return <BtnStyled to="/categories/Breakfast">Other categories</BtnStyled>;
};

export default СhooseYourBreakfast;
